import React from 'react';

import { Loadable } from '../../../components/navigation/Loadable';
import { allowedUserType, USER_TYPES } from '../../../utils/constants';
import { withPrivateRoute } from '../withPrivateRoute';

const { PATIENT } = USER_TYPES;

/**
 * @satisfies {ExtendedRouteObject}
 */
export const appointmentsRoutes = {
  name: 'Appointments',
  path: 'appointments',
  type: 'item',
  ...withPrivateRoute(Loadable(React.lazy(() => import('../../../components/appointments/appointments-container'))), {
    userCanAccess: ({ userType }) => allowedUserType([PATIENT], userType),
  }),
};
